<template>
  <div ref="component" class="cx_style deng cx-check-box">
    <el-checkbox v-model="syncValue" :disabled="isDisabled"
      ><slot></slot
      ><el-tooltip v-if="tips && tips.length" class="item" effect="dark" :content="tips" :placement="tipsPosition">
        <span class="layout_info icon-portal-info2"></span> </el-tooltip
    ></el-checkbox>
  </div>
</template>

<script>
import "../common.css"
import publicData from "../mixins/publicData.js"

export default {
  mixins: [publicData],
  name: "cxCheckBox",
  props: {
    value: {
      type: Boolean,
      required: true
    },
    tips: {
      type: String
    },
    tipsPosition: {
      type: String,
      default: "bottom"
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    syncValue: {
      get() {
        return this.value
      },
      set(val) {
        if (val === this.value) return
        this.$emit("change", Boolean(val))
        this.$emit("update:value", Boolean(val))
      }
    }
  }
}
</script>

<style></style>
